import { render } from "./comparePanel.vue?vue&type=template&id=212b91cf"
import script from "./comparePanel.vue?vue&type=script&lang=js"
export * from "./comparePanel.vue?vue&type=script&lang=js"

import "./comparePanel.vue?vue&type=style&index=0&id=212b91cf&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__